import type { UseIntl } from '../../types';
import { accountsApi } from '../../api';

import messages from './messages';

const DEFAULT_YEAR_OF_BIRTH = '1996';
const MAX_IMAGE_SIZE = 1 * 1024 * 1024; // 1MB

export const uploadImage = async (selectedFile: File, username: string, intl: UseIntl) => {
  if (selectedFile.size > MAX_IMAGE_SIZE) {
    // eslint-disable-next-line no-alert
    alert(intl.formatMessage(messages.fileSizeExceeded));
    return;
  }

  await accountsApi.updateUserImage(selectedFile, username);
};

export const setBirthDate = async (selectedFile: File, username: string, intl: UseIntl) => {
  const payload = { year_of_birth: DEFAULT_YEAR_OF_BIRTH };

  await accountsApi.updateUserMetaData(username, payload, () => {}, () => {});
  await uploadImage(selectedFile, username, intl);
};
